import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError} from 'rxjs';
import {LoggerService} from '../../shared/common-components/logger.service';
import {DataService} from '../data.service';
import {StateCountry} from 'src/app/shared/common-components/common-structure';


@Injectable({
  providedIn: 'root'
})
export class UserProfileService extends DataService {

  private baseURI = this.apiUri + '/userprofile/';
  private observable$: any;
  private _logger: LoggerService;

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  getUser(userId: string): Observable<any> {
    this.setUri(this.baseURI + userId + '/userId');
    return this.get();
  }

  getUserByOrganizationId(userId: string, organizationId: string): Observable<any> {
    this.setUri(this.baseURI + userId + '/userId/' + organizationId + '/organizationId');
    return this.get();
  }

  getUserOkta(userId: string): Observable<any> {
    this.setUri(this.apiUri + '/userprofile/' + userId + '/userIdOkta');
    return this.get();
  }

  getUserAccountSetup(userAccountSetupId: string): Observable<any> {
    this.setUri(this.apiUri + '/public/userprofile/' + userAccountSetupId + '/userIdOkta');
    // /public/userprofile/{userAccountSetupId}/userIdOkta
    return this.get();
  }

  getUserForOkta(userId: string): Observable<any> {
    this.setUri(this.baseURI + userId + '/userId');
    return this.get();
  }

  getAll(): Observable<any> {
    this.setUri(this.baseURI);
    return this.get();
  }

  updateProfile(user: any): Observable<any> {
    this.setUri(this.apiUri + '/userprofile/updateprofile');
    return this.update(user);
  }

  updateOKTA(user: any): Observable<any> {
    this.setUri(this.apiUri + '/accountinfo/saveAcct');
    return this.update(user);
  }

  getAllStates(stateCountryType): Observable<[StateCountry]> {
    this.setUri(this.baseURI + stateCountryType + 'statecountrytype');
    this.observable$ = this.http.get(this.baseURI + stateCountryType + '/statecountrytype').pipe(catchError(this.handleError));
    return this.observable$;
  }

  getCityState(zip: any): Observable<any> {
    this.setUri(this.baseURI + zip + '/zipcode/');
    return this.http.get(this.baseURI + zip + '/zipcode/').pipe(catchError(this.handleError));
  }

}
